import { useState } from 'react';
import Page from 'modules/app/components/Page';
import s from './AllSpecialists.module.scss';
import AllSpecialistsFilter from './AllSpecialistsFilter';
import AllSpecialistsList from './AllSpecialistsList';
import { useParams, useNavigate } from 'react-router-dom';
import useGetSalonById from 'sdk/hooks/salon/useGetSalonById';
import { useLocation } from 'react-router-dom';
import BackHeader from '../BackHeader';
import useIsAuth from 'sdk/hooks/useIsAuth';
const AllSpecialists = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { data: isAuthData } = useIsAuth();
  const { id } = useParams();
  const { data: salonData } = useGetSalonById(id);

  const [selectedService, setSelectedService] = useState('all');

  const handleBack = () => {
    navigate(`/salon/${id}`, {
      state: {
        tab: 3,
        restoreScroll: true,
        scrollPosition: location.state?.scrollPosition,
        fromBack: true,
      },
      replace: true,
    });
  };

  return (
    <div>
      <Page disableOverflow activeLink="/venues">
        <BackHeader title="Specialists" onBack={handleBack} />
        <div className={s.all_specialists_container}>
          <AllSpecialistsFilter
            salonId={salonData?.id}
            selectedService={selectedService}
            setSelectedService={setSelectedService}
          />
          <AllSpecialistsList serviceId={selectedService} salonId={salonData?.id} />
        </div>
      </Page>
    </div>
  );
};

export default AllSpecialists;
